import contactsTabModule from './contacts/contacts';
import infoTabModule from './info/info';
import adminsTabModule from './admins/admins';
import settingsTabModule from './settings/settings';
import reportsTabModule from './reports/reports';
import appearanceTabModule from './appearance/appearance';
import templatesTabModule from './templates/templates';
import botsTabModule from './bots/bots';
import billingTabModule from './billing/billing';
import billingPlansModule from './billing/billingPlans';
import objectsTabModule from './objects/objects';

export default angular
  .module('main.organizations.edit.tabs', [
    contactsTabModule,
    infoTabModule,
    adminsTabModule,
    settingsTabModule,
    reportsTabModule,
    appearanceTabModule,
    templatesTabModule,
    botsTabModule,
    billingTabModule,
    billingPlansModule,
    objectsTabModule,
  ])
  .name;
